import { Tooltip } from "antd";
import styles from "./style.module.less";

export const PendingDot = () => {
    return (
        <div className={styles.pendingDot}>
            <Tooltip placement="top" title="Pending">
                <i className="ri-checkbox-blank-circle-line"></i>
            </Tooltip>
        </div>
    );
}